/**
 * This custom hook provides the functionality to retrieve users to be shown in the UI.
 */

import {useContext, useState} from "react";
import {FirebaseAuthContext} from "../../../../commons/firebase/FirebaseAuthProvider";
import {useSnackbar} from "notistack";
import {useIntl} from "react-intl";

const useLoadVideoAutocompleteOptions = () => {
    const [autocompleteOptionsLoading, setAutocompleteOptionsLoading] = useState(false)

    const {signedInUser} = useContext(FirebaseAuthContext);
    const {enqueueSnackbar} = useSnackbar();

    // Internationalization for simple strings
    const intl = useIntl();

    // Get the already available autocomplete options (for the textfield auto suggestions)
    const fetchAutocompleteOptions = async (videoAssociation) => {
        setAutocompleteOptionsLoading(true)

        const idToken = await signedInUser.getIdToken()
        return fetch('/reg-main/videos/functions/autocompleteOptions?idToken=' + idToken + '&association=' + videoAssociation)
            .then(async (data) => {
                // Throw an error including the textual status of the HTTP response code (no detailed message necessary)
                if (data.status !== 200) {
                    throw new Error((await data.json()).status)
                }

                return data.json()
            })
            .catch((error) => {
                enqueueSnackbar(
                    intl.formatMessage({
                        id: 'app.videos.messages.load.video.autocomplete.error',
                        defaultMessage: 'Something went wrong while loading the autocomplete options for the video: {error}'
                    }, {error: error.message}), {
                        variant: 'error',
                        preventDuplicate: true,
                        autoHideDuration: 5000
                    });
            })
            .finally(() => {
                setAutocompleteOptionsLoading(false)
            })
    }

    return {
        autocompleteOptionsLoading,
        fetchAutocompleteOptions
    }
}
export default useLoadVideoAutocompleteOptions;